{
  "title": "Customers",
  "subtitle": "The people and companies you sell to, found at once by phone, name or email.",
  "anonymized": "Anonymized customer",
  "status": {
    "merged": "Merged",
    "anonymized": "Anonymized"
  },
  "types": {
    "person": "Person",
    "company": "Company"
  },
  "fields": {
    "type": "Type",
    "name": "Full name",
    "companyName": "Company name",
    "contactName": "Contact person",
    "taxId": "Tax ID",
    "phone": "Phone",
    "email": "Email",
    "tags": "Tags",
    "notes": "Notes",
    "marketingConsent": "Agrees to receive offers"
  },
  "form": {
    "newTitle": "New customer",
    "newHint": "A name is enough at the counter; add the rest when you have it.",
    "editTitle": "Edit {{number}}",
    "create": "Create customer",
    "saved": "Customer saved",
    "created": "Customer {{number}} created",
    "phoneHint": "Tunisian numbers need no +216.",
    "taxIdHint": "Matricule fiscal, printed on invoices.",
    "duplicatesTitle": "Already a customer?",
    "samePhone": "same phone {{phone}}",
    "sameEmail": "same email {{email}}",
    "tagsHint": "Groups such as VIP, plumber, wholesale. Enter or a comma adds a tag.",
    "tagsPlaceholder": "Add a tag",
    "removeTag": "Remove the tag {{tag}}",
    "notesHint": "About the customer, seen by the team only.",
    "consentHint": "Only with their agreement: you may then send them offers and news."
  },
  "list": {
    "new": "New customer",
    "export": "Export to Excel",
    "search": "Phone, name, email or number",
    "allTypes": "All types",
    "allTags": "All tags",
    "account": "Online account",
    "anyAccount": "With or without account",
    "withAccount": "With an online account",
    "withoutAccount": "Without online account",
    "hasAccount": "Has an online account",
    "sort": "Sort",
    "sorts": {
      "name_asc": "Name A to Z",
      "name_desc": "Name Z to A",
      "createdAt_desc": "Newest first",
      "createdAt_asc": "Oldest first"
    },
    "clear": "Clear filters",
    "showing_one": "{{first}}–{{last}} of {{total}} customer",
    "showing_other": "{{first}}–{{last}} of {{total}} customers"
  },
  "columns": {
    "customer": "Customer",
    "city": "City"
  },
  "empty": {
    "title": "No customer yet",
    "text": "Record the people and companies you sell to: their phone finds them at the counter, and their addresses serve deliveries."
  },
  "noMatch": {
    "title": "No customer found",
    "text": "Check the number or the spelling, or record a new customer."
  },
  "addresses": {
    "title": "Addresses",
    "add": "Add",
    "addTitle": "New address",
    "editTitle": "Edit the address",
    "none": "No address yet.",
    "untitled": "Address",
    "label": "Name",
    "labelHint": "Home, shop, building site…",
    "recipient": "Recipient",
    "line1": "Address",
    "line2": "Address line 2",
    "city": "City",
    "postalCode": "Postal code",
    "governorate": "Governorate",
    "phone": "Phone at this address",
    "phoneHint": "For the delivery, if not the customer’s.",
    "defaultDelivery": "Default delivery address",
    "defaultBilling": "Default billing address",
    "delivery": "Delivery",
    "billing": "Billing",
    "saved": "Address saved",
    "remove": "Remove",
    "removeTitle": "Remove this address?",
    "removed": "Address removed"
  },
  "merge": {
    "action": "Merge another customer here",
    "title": "Merge a customer into {{number}}",
    "hint": "Pick the duplicate. It joins this customer, which keeps its own details.",
    "search": "Customer to merge",
    "duplicates": "Same phone or email",
    "typeToSearch": "Search the other customer by phone, name, email or number.",
    "summaryTitle": "What happens",
    "summary": "The details this customer lacks, the addresses, tags, notes, online account and history of {{source}} come here. {{source}} then points here and can no longer be changed.",
    "confirm": "Merge",
    "done": "{{source}} merged into {{target}}"
  },
  "timeline": {
    "title": "Timeline",
    "hint": "Changes, notes and requests, newest first, with the orders.",
    "kindLabel": "Kind of entry",
    "kinds": {
      "note": "Note",
      "request": "Request"
    },
    "notePlaceholder": "Something the team should know",
    "requestPlaceholder": "What the customer asked for",
    "addNote": "Add note",
    "addRequest": "Add request",
    "noteAdded": "Note added",
    "requestAdded": "Request added",
    "personal": "Changed: {{fields}}",
    "personalEntered": "Entered: {{fields}}",
    "theCustomer": "The customer",
    "empty": "Nothing yet.",
    "more": "Load {{count}} more"
  },
  "account": {
    "title": "Online account",
    "badge": "Online account",
    "none": "No online account. Customers create theirs on the online store.",
    "status": "Email address",
    "verified": "Confirmed",
    "pending": "Not confirmed yet",
    "created": "Created",
    "lastSignIn": "Last sign-in",
    "passwordLink": "Password link",
    "linkTitle": "Link to choose a new password",
    "linkText": "Send it to the customer, by message for example. It works once, for {{minutes}} minutes, and ends the customer's other sessions.",
    "copy": "Copy the link",
    "copied": "Link copied"
  },
  "page": {
    "more": "More actions",
    "contact": "Contact",
    "yes": "Yes",
    "no": "No",
    "created": "Created",
    "lastChange": "Last change",
    "dateBy": "{{date}} by {{name}}",
    "mergedTitle": "Merged",
    "mergedText": "This customer was merged into",
    "anonymizedTitle": "Anonymized",
    "anonymizedText": "Their personal details were removed on {{date}}, at their request.",
    "duplicatesTitle_one": "A possible duplicate",
    "duplicatesTitle_other": "{{count}} possible duplicates",
    "same": {
      "phone": "same phone",
      "email": "same email"
    },
    "mergeHere": "Merge here",
    "newOrder": "New order",
    "recordPayment": "Record a payment"
  },
  "anonymize": {
    "action": "Anonymize",
    "title": "Anonymize {{number}}?",
    "text": "Their name, phone, email, tax ID, addresses, tags, notes and online account are removed for good, also from customers merged into them. Their orders stay, without personal details. This cannot be undone.",
    "confirm": "Anonymize",
    "done": "{{number}} anonymized"
  },
  "delete": {
    "action": "Delete",
    "title": "Delete {{number}}?",
    "text": "This customer was never used: it is removed for good. The activity log keeps a record of the deletion.",
    "confirm": "Delete",
    "done": "{{number}} deleted"
  },
  "tabs": {
    "orders": "Orders",
    "payments": "Payments",
    "timeline": "Timeline",
    "details": "Details"
  },
  "figures": {
    "open": "Still to pay",
    "openOrders_one": "On {{count}} order",
    "openOrders_other": "On {{count}} orders",
    "total": "Ordered",
    "orders_one": "{{count}} order",
    "orders_other": "{{count}} orders",
    "paid": "Paid",
    "refunded": "Refunded"
  },
  "orders": {
    "empty": "No orders yet.",
    "order": "Order",
    "date": "Date",
    "status": "Status",
    "payment": "Payment",
    "total": "Total",
    "paid": "Paid",
    "due": "Still due"
  },
  "payments": {
    "empty": "No payments yet.",
    "date": "Date",
    "method": "Method",
    "pays": "Pays",
    "amount": "Amount",
    "status": "Status",
    "received": "Received",
    "showing_one": "{{first}}–{{last}} of {{total}} payment",
    "showing_other": "{{first}}–{{last}} of {{total}} payments"
  }
}
